module.exports = __webpack_public_path__ + "assets/f5833fc2193fc87b86f047d55b1b8dd9.png";